import { DatepickerError, MultipleFieldDatepickerProps } from './types';

const commonPartsErrors: DatepickerError['type'][] = [
  'minDate',
  'maxDate',
  'disabledDate',
  'format',
];
const dayErrors: DatepickerError['type'][] = [
  ...commonPartsErrors,
  'invalidDay',
  'emptyDay',
];
const monthErrors: DatepickerError['type'][] = [
  ...commonPartsErrors,
  'invalidMonth',
  'emptyMonth',
];
const yearErrors: DatepickerError['type'][] = [
  ...commonPartsErrors,
  'invalidYear',
  'emptyYear',
];
const partsErrors = {
  day: dayErrors,
  month: monthErrors,
  year: yearErrors,
} as const;

/**
 * Необходима для отображения ошибок в полях MultipleFieldDatepicker.
 * Возвращает массив полей, в которых произошли ошибки, на основе ошибок полученных из _стандартных_ валидаторов.
 */
export const getDatePartsErrors = (errors: DatepickerError[] | undefined) => {
  if (!errors) return undefined;

  const dateParts: MultipleFieldDatepickerProps['errors'] = [];
  Object.entries(partsErrors).forEach(([part, possibleErrorTypes]) => {
    const isPartError = errors.some(
      (error) =>
        possibleErrorTypes.includes(error.type) ||
        (error.type === 'extraSymbols' && error.part === part)
    );
    if (isPartError) dateParts.push(part as keyof typeof partsErrors);
  });

  return dateParts.length ? dateParts : undefined;
};
